import { useAdicionarEscopoMacroDialog } from "./use-adicionar-escopo-macro-dialog";
import { AdicionarEscopoMacroDialogView } from "./view-adicionar-escopo-macro-dialog";
import type { AdicionarEscopoMacroDialogProps } from "./types-adicionar-escopo-macro-dialog";

export function AdicionarEscopoMacroDialog(props: AdicionarEscopoMacroDialogProps) {
  const vm = useAdicionarEscopoMacroDialog(props);

  return <AdicionarEscopoMacroDialogView {...vm} />;
}

export type * from "./types-adicionar-escopo-macro-dialog";
